import type { ComponentType, ReactNode } from "react";
import type { Icon } from "iconsax-react";
import cn from "classnames";
import { FileViewer } from "@/shared/ui";

interface Props {
  label: string;
  value: string;
  icon: Icon | ComponentType<{ size?: number; color?: string }>;
  isStatus?: boolean;
  statusComponent?: ReactNode;
  isPdfFile?: boolean;
  pdfPrimaryUrl?: string;
  pdfSecondaryUrl?: string;
  isLast?: boolean;
}

export default function DetailFieldRow({
  label,
  value,
  icon: IconComponent,
  isStatus,
  statusComponent,
  isPdfFile,
  pdfPrimaryUrl,
  pdfSecondaryUrl,
  isLast,
}: Props) {
  if (isPdfFile) {
    if (!pdfPrimaryUrl) return null;
    return (
      <div className={cn("py-3 flex flex-col gap-3", !isLast && "border-b surface-base-stroke")}>
        <div className="flex items-center gap-3">
          <span className="content-action-brand">
            <IconComponent size={16} color="currentColor" />
          </span>
          <span className="text-body-regular-md content-base-secondary">{label}</span>
        </div>
        <FileViewer existingFileUrl={pdfPrimaryUrl} secondaryFileUrl={pdfSecondaryUrl} />
      </div>
    );
  }

  return (
    <div className={cn("py-3 flex items-center gap-3", !isLast && "border-b surface-base-stroke")}>
      <span className="content-action-brand">
        <IconComponent size={16} color="currentColor" />
      </span>
      <span className="text-body-regular-md content-base-secondary flex-1 min-w-[108px]">{label}</span>
      {isStatus ? (
        <div className="flex justify-end">{statusComponent}</div>
      ) : (
        <p className="text-body-bold-md content-base-primary text-right">{value}</p>
      )}
    </div>
  );
}
